// Termos e Condições de Uso do Programa Cannect de Cuidado para Perda de Peso. Texto jurídico: não reescrever sem
// aval do jurídico, e subir TERMS_VERSION a cada mudança (a versão aceita é gravada na sessão da triagem).
//
// Formato do texto: "## " abre uma seção, linhas "- " formam uma lista e o resto são parágrafos (separados por
// linha em branco).
export const TERMS_VERSION = '1.0'

export const TERMS_TITLE = 'Termos e Condições de Uso'

export const TERMS_SUBTITLE = 'Programa Cannect de Cuidado para Perda de Peso'

export const TERMS_TEXT = `
Bem-vindo(a) ao Programa Cannect de Cuidado para Perda de Peso.

O Programa foi desenvolvido para oferecer jornada estruturada e multidisciplinar de cuidado, reunindo avaliação médica, acompanhamento nutricional, avaliação psicológica, acompanhamento de enfermagem e, quando houver indicação clínica, tratamento medicamentoso prescrito por profissional médico habilitado.

Estes Termos estabelecem as regras aplicáveis à contratação e utilização do Programa e devem ser lidos em conjunto com o Resumo da Contratação disponibilizado antes do aceite.

## 1. QUEM É A CANNECT

A CANNECT SERVIÇOS DE INTERNET S/A, inscrita no CNPJ sob nº 41.418.943/0001-16, com sede na Rua Gomes de Carvalho, nº 1507, 15º andar, Vila Olímpia, São Paulo/SP, CEP 04547-005 (“Cannect”), atua na organização e gestão da jornada do Programa, integração operacional de prestadores, disponibilização de recursos tecnológicos, agendamento, comunicação, acompanhamento administrativo e suporte ao usuário.

Os atendimentos e demais atos privativos das profissões de saúde são executados por profissionais legalmente habilitados, observadas suas competências e autonomia técnica. Quando houver fornecimento de medicamentos, a dispensação e a comercialização serão realizadas pelo estabelecimento farmacêutico identificado ao usuário, na forma da Seção 9.

A indicação dos prestadores e o detalhamento de quem efetivamente prestará cada serviço constarão da jornada e/ou do Resumo da Contratação. A distribuição das atividades não afasta responsabilidades legais que não possam ser excluídas, especialmente os direitos assegurados pelo Código de Defesa do Consumidor.

## 2. SOBRE O PROGRAMA

O Programa Cannect de Cuidado para Perda de Peso é uma jornada multidisciplinar destinada a pessoas maiores de idade que buscam acompanhamento profissional para controle de peso e melhoria da saúde.

O ciclo inicial tem duração de 3 (três) meses, ressalvada condição expressamente destacada no Resumo da Contratação apresentado antes do aceite. Conforme a oferta contratada, a jornada assistencial compreende:

- consulta médica inicial;
- consulta médica de acompanhamento;
- 2 (duas) consultas com nutricionista;
- avaliação psicológica;
- acompanhamento de enfermagem, segundo a frequência e o formato informados na oferta;
- monitoramento da evolução e acesso aos canais de acompanhamento do Programa, conforme as condições divulgadas;

O tratamento medicamentoso não constitui prestação automática ou garantida: poderá integrar a condição comercial contratada exclusivamente se houver indicação clínica e prescrição médica válida. Sua inclusão financeira, abrangência e limites deverão constar de maneira expressa e destacada no Resumo da Contratação.

Antes do pagamento, o usuário receberá, de modo claro e acessível, a descrição dos serviços incluídos, quantidade de consultas, duração, início do ciclo, forma de agendamento, eventuais limites de uso, política de faltas e remarcações, medicamentos eventualmente contemplados, itens não incluídos, preço total, tributos e condições de pagamento e cancelamento.

Alterações clínicas poderão demandar ajustes na condução do cuidado, sempre por profissional habilitado. Alterações relevantes da oferta que reduzam prestações ou imponham custo adicional dependerão de prévia informação e, quando cabível, concordância do usuário, sem prejuízo de seus direitos legais.

## 3. QUEM PODE PARTICIPAR

O Programa é destinado a pessoas maiores de 18 anos e com capacidade civil para contratar os serviços.

O preenchimento de questionários, cálculo de IMC, pré-triagens digitais ou outras etapas anteriores à consulta médica não significam aprovação para tratamento medicamentoso.

A participação no Programa dependerá da avaliação das informações fornecidas pelo usuário e, quando aplicável, da avaliação dos profissionais responsáveis.

Determinadas condições clínicas poderão exigir:

- informações adicionais;
- realização de exames;
- avaliação de outro especialista;
- adiamento do início do Programa; ou
- indicação de outra modalidade de cuidado.

## 4. QUESTIONÁRIO E AVALIAÇÃO INICIAL

Antes da avaliação profissional, o usuário poderá responder questionários relacionados a:

- peso e altura;
- histórico de peso;
- hábitos e rotina;
- condições de saúde;
- medicamentos em uso;
- tratamentos anteriores;
- objetivos pessoais;
- histórico clínico e demais informações relevantes à jornada de cuidado.

Esses questionários possuem finalidade de coleta, organização e direcionamento das informações.

O resultado apresentado pela plataforma antes da avaliação profissional possui caráter informativo e não constitui:

- diagnóstico;
- prescrição;
- indicação de medicamento;
- definição de dose;
- contraindicação médica definitiva; ou
- garantia de elegibilidade para determinado tratamento.

## 5. USO DE TECNOLOGIA, AUTOMAÇÕES E INTELIGÊNCIA ARTIFICIAL

A Cannect poderá empregar sistemas digitais, algoritmos, automações e ferramentas de inteligência artificial para coleta e organização de informações, cálculo de indicadores objetivos (como IMC), lembretes, direcionamento de fluxos, comunicação, apoio administrativo e identificação de situações que precisem de revisão humana.

Esses recursos não substituem a avaliação individualizada por profissional de saúde habilitado, nem atuam como responsáveis autônomos por decisões clínicas. Diagnóstico, definição de tratamento, escolha ou alteração de medicamento, dose, titulação, suspensão e demais condutas privativas são realizadas apenas por profissional habilitado.

Quando o processamento automatizado contribuir para um encaminhamento inicial, o usuário poderá solicitar esclarecimentos e a avaliação humana pertinente pelos canais do Programa. A coleta e o uso de informações pessoais, inclusive dados de saúde, observarão as bases legais, a necessidade, a segurança e a transparência previstas na Seção 21.

## 6. AVALIAÇÃO E AUTONOMIA MÉDICA

As decisões médicas são tomadas exclusivamente pelo médico responsável pelo atendimento, com autonomia técnica e profissional.

Compete exclusivamente ao médico, dentro de suas atribuições profissionais:

- realizar a avaliação clínica;
- estabelecer diagnóstico, quando aplicável;
- avaliar riscos e contraindicações;
- solicitar exames;
- avaliar a necessidade ou não de tratamento medicamentoso;
- escolher o medicamento adequado;
- determinar a dose;
- realizar ou orientar titulação;
- modificar o tratamento;
- suspender medicamentos;
- indicar avaliação presencial ou por outro especialista.

A participação no Programa não garante a prescrição de qualquer medicamento específico.

O médico poderá concluir, após avaliação individualizada, que o usuário:

- a) possui indicação de tratamento medicamentoso;
- b) pode participar do acompanhamento sem tratamento medicamentoso;
- c) necessita de exames ou avaliações complementares;
- d) deve realizar avaliação presencial; ou
- e) não deve iniciar ou continuar determinada estratégia terapêutica.

## 7. TELEMEDICINA E TELESSAÚDE

Os atendimentos do Programa poderão ocorrer presencialmente ou por telemedicina/telessaúde, quando permitidos pela legislação e pelas normas aplicáveis a cada profissão, conforme as condições assistenciais e comerciais previamente informadas.

Os atendimentos remotos poderão utilizar videochamada, mensagens, formulários, documentos, imagens, exames e outros meios tecnológicos adequados e seguros, conforme avaliação do profissional responsável.

O usuário será informado, antes do atendimento, sobre os aspectos relevantes da modalidade remota. Será colhido consentimento livre e esclarecido específico quando exigido pela legislação e pelas normas profissionais, com o respectivo registro.

O profissional poderá determinar a necessidade de atendimento presencial quando considerar os recursos remotos insuficientes. O usuário possui os direitos previstos na legislação de telessaúde, inclusive de recusa da modalidade remota e de atendimento presencial quando solicitado, observada a organização do serviço e a indicação dos canais/locais aplicáveis. A impossibilidade de prosseguimento pela modalidade originalmente contratada será tratada de forma transparente, com solução assistencial ou contratual compatível com a legislação.

O Programa não equivale a atendimento de urgência ou emergência e não substitui os serviços destinados a essas situações.

## 8. TRATAMENTO MEDICAMENTOSO

O Programa poderá contemplar tratamento medicamentoso durante o período contratado somente quando houver avaliação individualizada e prescrição médica válida, observadas as condições comerciais e sanitárias aplicáveis.

A contratação do Programa não constitui, por si só, compra de medicamento, garantia de prescrição, promessa de fornecimento de produto específico ou compromisso de obtenção de resultado terapêutico.

A escolha da substância, apresentação, dose, titulação, duração do uso, necessidade de exames e interrupção do tratamento competem exclusivamente ao médico responsável. A Cannect não poderá modificar prescrição por decisão administrativa, comercial ou automatizada.

Qualquer medicamento poderá ser dispensado exclusivamente por estabelecimento farmacêutico regular e mediante o cumprimento dos requisitos de prescrição, retenção de receita, rastreabilidade, conservação e entrega pertinentes. Quando aplicável à classe farmacológica, serão observadas as exigências específicas da Anvisa.

Caso um medicamento ou dose não esteja abrangido pela oferta, a diferença de preço e as alternativas de continuidade deverão ser informadas ao usuário antes de qualquer cobrança ou fornecimento adicionais, respeitada a autonomia clínica.

## 9. DISPENSAÇÃO E FORNECIMENTO DE MEDICAMENTOS

A dispensação e a comercialização de medicamentos, quando clinicamente indicados, serão realizadas exclusivamente por farmácia ou drogaria habilitada, licenciada e identificada ao usuário previamente à respectiva operação, com indicação de razão social, CNPJ e canais de atendimento pertinentes.

O estabelecimento farmacêutico executará, dentro de suas atribuições e da legislação aplicável, a conferência da receita e de seus requisitos, a retenção e os registros legalmente exigidos, a dispensação, o faturamento, a emissão de documento fiscal, a guarda e conservação, o acondicionamento, a rastreabilidade e o transporte e/ou entrega, quando cabível.

Os medicamentos sujeitos à exigência de receita ou retenção específica somente poderão ser fornecidos após o cumprimento das regras pertinentes. A escolha do medicamento permanece ato médico, e a dispensação permanece ato do estabelecimento farmacêutico.

Em se tratando de medicamento que exija condições particulares de conservação, transporte ou administração, o estabelecimento farmacêutico e a equipe assistencial disponibilizarão, cada qual em sua competência, as informações necessárias para uma utilização segura.

Em caso de atraso, extravio, avaria, suspeita de irregularidade de qualidade, incompatibilidade entre prescrição e produto ou falha de entrega, o usuário deverá acionar os canais informados para solução do problema. A atribuição de responsabilidades entre fornecedores não limita os direitos que a legislação assegura ao consumidor.

## 10. ACOMPANHAMENTO DE ENFERMAGEM

Durante o Programa, o usuário poderá ser acompanhado pela equipe de enfermagem.

O acompanhamento poderá incluir:

- contato periódico;
- registro da evolução do peso;
- acompanhamento de adesão;
- registro de sintomas;
- orientação dentro das atribuições profissionais;
- lembretes;
- identificação de intercorrências;
- encaminhamento ao médico ou a outro profissional.

A equipe de enfermagem não realizará alteração autônoma da prescrição ou da dose de medicamentos quando essa decisão for de competência médica.

Situações que demandem mudança terapêutica serão encaminhadas para avaliação do profissional responsável.

## 11. ACOMPANHAMENTO NUTRICIONAL

O Programa contempla 2 (duas) consultas com nutricionista, salvo condição comercial diferente expressamente apresentada ao usuário.

O nutricionista atuará dentro de suas competências profissionais, podendo avaliar hábitos alimentares, rotina, objetivos, dificuldades, evolução e outras informações relacionadas ao cuidado nutricional.

As orientações nutricionais serão individualizadas de acordo com a avaliação do profissional.

## 12. AVALIAÇÃO PSICOLÓGICA

O Programa contempla avaliação psicológica voltada à compreensão de fatores emocionais e comportamentais que possam influenciar a jornada de controle de peso.

A avaliação não significa necessariamente indicação de tratamento psicológico continuado.

Quando o profissional identificar necessidade de acompanhamento adicional, poderá orientar o usuário a procurar serviço ou profissional apropriado.

## 13. CONSULTA MÉDICA DE ACOMPANHAMENTO

Durante o ciclo contratado, será realizada consulta médica de acompanhamento, conforme programação do Programa e avaliação clínica.

O médico poderá revisar:

- evolução do peso;
- tolerabilidade ao tratamento;
- sintomas;
- exames;
- adesão;
- resposta terapêutica;
- necessidade de manutenção, modificação ou interrupção da estratégia adotada.

Qualquer decisão terapêutica será realizada pelo médico responsável.

## 14. RESULTADOS DO PROGRAMA

Os resultados de perda de peso variam entre indivíduos.

A Cannect não garante:

- quantidade determinada de quilos perdidos;
- percentual específico de redução de peso;
- prazo determinado para obtenção de resultado;
- manutenção permanente do peso;
- resposta específica a medicamentos;
- ausência de efeitos adversos.

Exemplos, estimativas, médias e informações de estudos eventualmente apresentados pela Cannect possuem caráter informativo e não representam garantia de resultado individual.

## 15. RESPONSABILIDADES DO USUÁRIO

Para segurança da jornada, o usuário compromete-se a:

- fornecer informações completas, verdadeiras e atualizadas;
- informar condições de saúde existentes;
- comunicar os medicamentos e suplementos utilizados;
- informar alergias, tratamentos anteriores e intercorrências;
- comunicar eventual gravidez ou suspeita de gravidez, quando aplicável;
- seguir as orientações dos profissionais responsáveis;
- utilizar medicamentos somente conforme prescrição;
- não compartilhar medicamento prescrito para uso pessoal;
- não alterar doses por conta própria;
- comparecer às consultas e acompanhamentos agendados;
- informar imediatamente alterações relevantes de saúde;
- procurar atendimento de urgência quando necessário.

O fornecimento de informações falsas, incompletas ou omitidas poderá comprometer a segurança do atendimento e levar à suspensão ou encerramento da participação no Programa.

## 16. SINTOMAS E EVENTOS ADVERSOS

O usuário deverá comunicar ao time assistencial sintomas ou possíveis eventos adversos identificados durante sua participação no Programa.

A equipe poderá realizar orientação inicial dentro de suas competências e, quando necessário, encaminhar o usuário para avaliação médica.

O Programa e seus canais digitais não substituem serviços de urgência e emergência.

Em situações graves, de piora súbita ou que apresentem risco à saúde, o usuário deverá buscar imediatamente serviço presencial de urgência ou emergência.

## 17. FARMACOVIGILÂNCIA

Informações sobre suspeitas de eventos adversos, intercorrências ou problemas relacionados ao uso de medicamentos poderão ser registradas e tratadas pelos profissionais envolvidos no cuidado.

Quando aplicável, essas informações poderão ser encaminhadas às autoridades sanitárias ou aos sistemas oficiais de farmacovigilância, observadas as obrigações legais e a legislação de proteção de dados.

## 18. VALOR E CONDIÇÕES DE PAGAMENTO

Antes da conclusão da contratação, o usuário terá acesso ao Resumo da Contratação, com identificação da oferta, prazo de vigência, data ou evento de início do ciclo, itens assistenciais incluídos, eventual tratamento medicamentoso contemplado, exclusões, preço total, periodicidade de cobrança, formas de pagamento, tributos e encargos aplicáveis, condições de remarcação e política de cancelamento e reembolso.

A confirmação da contratação dependerá de aceite expresso dos Termos e do Resumo da Contratação, com possibilidade de conservação desses documentos pelo usuário. A Cannect disponibilizará confirmação da contratação pelos canais indicados, nos termos da legislação aplicável.

Quando serviços ou produtos forem prestados/comercializados por pessoas jurídicas distintas, a identidade do responsável por cada componente, o beneficiário do pagamento, a eventual cobrança separada e a emissão dos documentos fiscais correspondentes deverão ser informados de forma clara, observada a natureza de cada operação.

Nenhum medicamento, ajuste de dose, consulta adicional ou outro componente não abrangido pela oferta poderá gerar cobrança adicional sem informação clara e autorização do usuário, ressalvadas hipóteses legais específicas.

## 19. MEDICAMENTO NÃO PRESCRITO OU ALTERAÇÃO DO TRATAMENTO

A inclusão comercial de medicamento em determinada oferta não interfere na autonomia do médico nem significa garantia de prescrição.

Na hipótese de não haver indicação clínica, existir contraindicação, ser prescrito medicamento diverso do inicialmente considerado, ocorrer mudança de dose, suspensão do tratamento ou impossibilidade regulatória de fornecimento, prevalecerá a decisão clínica e sanitária aplicável.

Nessas situações, a Cannect apresentará ao usuário, de forma individualizada e antes de qualquer alteração de cobrança, a recomposição econômica da oferta contratada, explicitando os componentes mantidos, aqueles não executados, eventuais diferenças de preço e alternativas de continuidade ou encerramento.

Quando não houver fornecimento de componente já pago, o usuário terá direito à solução proporcional ou à restituição correspondente, sem prejuízo de outros direitos legalmente assegurados, observadas as regras de desistência e cancelamento da Seção 20.

Não haverá substituição automática do medicamento originalmente considerado na oferta, tampouco obrigação de aceitar produto, preço ou tratamento não aprovado pelo usuário e pelo profissional competente, quando aplicável.

## 20. CANCELAMENTO, DESISTÊNCIA E REEMBOLSO

O usuário poderá solicitar cancelamento, desistência ou esclarecimentos pelos canais oficiais divulgados antes da contratação. A Cannect confirmará o recebimento da solicitação e apresentará a resposta e a apuração financeira correspondentes, observados os prazos legais.

Nas contratações realizadas fora do estabelecimento comercial, inclusive por meio eletrônico, será assegurado o direito de arrependimento no prazo legal de 7 (sete) dias, previsto no art. 49 do Código de Defesa do Consumidor, com restituição dos valores pagos, observada a legislação aplicável. O exercício desse direito não dependerá de justificativa e poderá ser realizado também pela ferramenta utilizada na contratação.

Após o prazo legal de arrependimento, o usuário poderá solicitar o encerramento do Programa. A apuração de valores observará as prestações efetivamente executadas, valores individualizados ou critérios objetivos previamente informados na oferta, despesas legítimas e comprováveis quando juridicamente cabíveis, e o saldo relativo aos serviços não prestados, vedadas retenções ou penalidades abusivas.

Consultas não realizadas, serviços não prestados e medicamentos não dispensados deverão ter tratamento econômico transparente e compatível com a legislação. O simples agendamento ou preparação administrativa não poderá ser equiparado automaticamente a serviço integralmente prestado.

Medicamentos que já tenham sido dispensados ou entregues submetem-se às regras sanitárias e consumeristas próprias. A possibilidade ou restrição de devolução física não afasta, por si só, direitos decorrentes de defeito, vício, entrega inadequada, publicidade enganosa ou descumprimento da oferta.

Em caso de encerramento por contraindicação ou impossibilidade clínica/operacional de continuidade, serão discriminadas as prestações realizadas e aquelas não executadas, com devolução dos valores correspondentes quando devida. A disciplina prevista nesta Seção integra o Resumo da Contratação e não prejudica regras legais mais favoráveis ao consumidor.

## 21. TRATAMENTO DE DADOS PESSOAIS E DADOS DE SAÚDE

Para viabilizar o Programa, poderá ocorrer tratamento de dados pessoais e de dados pessoais sensíveis, especialmente informações relativas à saúde, estritamente para finalidades legítimas, específicas e necessárias à prestação do cuidado, à gestão operacional, à segurança do usuário, ao cumprimento de obrigações legais/regulatórias e ao exercício regular de direitos.

As categorias de dados tratados poderão compreender identificação e contato, informações clínicas fornecidas pelo usuário ou geradas em atendimento, prescrições, exames, histórico de saúde, dados de acompanhamento e informações relacionadas a pagamentos, na medida estritamente necessária à finalidade correspondente.

Os dados poderão ser compartilhados somente quando necessário e de forma compatível com a legislação, com profissionais e serviços de saúde, farmácias, laboratórios, plataformas tecnológicas e outros prestadores envolvidos, observados o sigilo profissional, os papéis efetivos de cada agente de tratamento, as bases legais aplicáveis e as medidas de segurança pertinentes.

O tratamento de dados sensíveis de saúde dependerá de hipótese legal adequada ao caso concreto, nos termos do art. 11 da LGPD. A adesão a estes Termos não equivale a consentimento amplo e irrestrito para quaisquer finalidades, nem autoriza compartilhamento de dados de saúde para obtenção de vantagem econômica em desconformidade com a legislação.

Quando aplicável, poderão ser utilizadas ferramentas automatizadas e fornecedores tecnológicos, inclusive com processamento em ambientes externos, sempre com controles de acesso, confidencialidade, critérios de segurança, informações sobre eventual transferência internacional de dados e demais salvaguardas legais pertinentes.

A Política de Privacidade, apresentada em linguagem clara e disponibilizada ao usuário antes da coleta pertinente, detalhará finalidades, hipóteses legais, categorias de destinatários, retenção, direitos do titular, identificação dos agentes responsáveis e contato para exercício de direitos. Consentimentos autônomos e específicos serão colhidos quando exigidos por lei.

O uso de dados de saúde para publicidade, segmentação comercial ou finalidade não relacionada ao cuidado não decorre automaticamente da contratação e dependerá de avaliação jurídica própria e do cumprimento das restrições legais aplicáveis.

## 22. PRONTUÁRIO E REGISTROS ASSISTENCIAIS

Os atendimentos deverão ser registrados em prontuários e demais registros assistenciais conforme a legislação e as normas dos conselhos profissionais aplicáveis, por quem detenha a respectiva responsabilidade assistencial.

A guarda, a integridade, o sigilo, os acessos permitidos, o compartilhamento necessário e os prazos de conservação observarão as regras legais e profissionais pertinentes. O acesso administrativo da Cannect não pressupõe disponibilidade irrestrita de dados clínicos protegidos por sigilo.

O usuário poderá solicitar acesso, esclarecimentos e o exercício dos direitos relativos aos seus dados e documentos pelos canais informados, ressalvadas as hipóteses legítimas de conservação obrigatória e as exigências de sigilo profissional.

## 23. COMUNICAÇÕES

A Cannect e os profissionais envolvidos no Programa poderão entrar em contato com o usuário pelos canais fornecidos no cadastro, incluindo:

- WhatsApp;
- telefone;
- e-mail;
- aplicativo;
- notificações da plataforma.

As comunicações poderão envolver:

- consultas;
- acompanhamento assistencial;
- questionários;
- solicitações de informações;
- lembretes;
- acompanhamento da evolução;
- questões operacionais;
- entrega;
- suporte.

Comunicações publicitárias ou promocionais observarão as preferências e permissões aplicáveis.

## 24. SERVIÇOS E PROFISSIONAIS TERCEIROS

Consultas e demais atividades assistenciais poderão ser executadas por médicos, nutricionistas, psicólogos, profissionais de enfermagem, clínicas, laboratórios e outros prestadores habilitados. A dispensação e a comercialização de medicamentos caberão ao estabelecimento farmacêutico regular identificado ao usuário.

Cada profissional ou estabelecimento atuará conforme suas competências e obrigações técnicas, assistenciais e regulatórias. A Cannect responderá por suas próprias atividades e pelas responsabilidades que a legislação lhe atribuir em razão da oferta, organização, intermediação e participação na cadeia de fornecimento.

A utilização de terceiros não afasta a tutela dos direitos do consumidor, nem constitui renúncia prévia a direitos, garantias ou responsabilidades legalmente exigíveis.

## 25. CONTEÚDO EDUCACIONAL

Informações disponibilizadas no site, aplicativo, materiais, mensagens ou demais canais da Cannect podem conter conteúdo educativo sobre saúde, alimentação, controle de peso, medicamentos ou qualidade de vida.

Essas informações são gerais e não substituem uma avaliação individualizada realizada por profissional de saúde.

O usuário não deverá iniciar, interromper ou modificar tratamento com base exclusivamente em conteúdo educativo disponibilizado na plataforma.

## 26. PROPRIEDADE INTELECTUAL

Os conteúdos, sistemas, marcas, textos, imagens, materiais, funcionalidades, metodologias e demais elementos disponibilizados pela Cannect são protegidos pelas normas aplicáveis de propriedade intelectual.

O usuário recebe autorização limitada para utilização pessoal dos recursos necessários à sua participação no Programa.

É vedada sua reprodução, comercialização, distribuição, modificação ou exploração sem autorização da Cannect ou do respectivo titular.

## 27. DISPONIBILIDADE DA PLATAFORMA

A Cannect empregará esforços razoáveis para manter os recursos digitais do Programa disponíveis e seguros.

Interrupções temporárias poderão ocorrer em razão de:

- manutenção;
- atualizações;
- falhas de fornecedores;
- indisponibilidade de telecomunicações;
- força maior;
- questões de segurança.

Quando possível, a Cannect adotará medidas para restabelecer o serviço e reduzir impactos sobre o acompanhamento do usuário.

## 28. ALTERAÇÃO DOS TERMOS

Estes Termos poderão ser atualizados para refletir alterações legislativas, sanitárias, tecnológicas, de segurança ou da organização do Programa. A versão vigente ficará identificada e acessível nos canais oficiais.

Alterações com impacto material em preço, composição do pacote, direitos, deveres ou prestação de serviços já contratados serão comunicadas previamente e não serão impostas retroativamente de forma unilateral ou em prejuízo do usuário, ressalvadas determinações legais ou sanitárias de aplicação obrigatória.

Se determinada mudança necessária inviabilizar a continuidade nos moldes originalmente contratados, serão apresentadas alternativas legais e assistencialmente adequadas e, quando devido, o encerramento com a apuração proporcional dos valores.

## 29. ENCERRAMENTO DA PARTICIPAÇÃO

A participação poderá ser encerrada ao fim do prazo contratado, por solicitação do usuário, por decisão clínica fundamentada na segurança do paciente, por descumprimento relevante destes Termos, por impossibilidade legal, sanitária ou operacional de prestação, ou nas demais hipóteses previstas na legislação.

Sempre que possível e adequado à segurança assistencial, o usuário será informado sobre o encerramento e sobre a orientação de continuidade do cuidado. Eventual apuração financeira observará a Seção 20, vedado o afastamento de direitos legalmente assegurados.

O encerramento não impede a conservação dos registros cujo armazenamento seja exigido por lei e pelas normas profissionais pertinentes.

## 30. DISPOSIÇÕES GERAIS

Estes Termos devem ser lidos juntamente com o Resumo da Contratação, a Política de Privacidade, os consentimentos específicos pertinentes, os documentos assistenciais, as prescrições médicas e as orientações de cancelamento disponibilizadas antes da contratação.

Na hipótese de divergência, prevalecerão as normas legais obrigatórias e a condição contratual que assegure os direitos do consumidor, sem prejuízo das informações específicas da oferta expressamente aceitas.

A invalidade de determinada disposição não afetará, por si só, a eficácia das demais. Nenhuma cláusula poderá ser interpretada como renúncia a direitos assegurados ao usuário pelo ordenamento jurídico brasileiro.

## 31. CONTATO

Para dúvidas relacionadas ao Programa, o usuário poderá utilizar os canais oficiais disponibilizados pela Cannect.

Atendimento: faleconosco@cannect.com.br

Site: cannect.life

## 32. ACEITE

Antes de finalizar a contratação, o usuário deverá ter acesso a estes Termos, ao Resumo da Contratação e à Política de Privacidade, em formato que permita leitura e conservação.

Ao selecionar a opção específica de aceite, o usuário declara ter tido oportunidade de ler os documentos, esclarecer dúvidas e compreender a composição do pacote, os limites e requisitos do eventual tratamento medicamentoso, as regras comerciais, a inexistência de garantia de resultado e as atribuições dos profissionais responsáveis.

O aceite dos Termos não substitui o consentimento livre e esclarecido exigido para telemedicina ou outros atos assistenciais, nem constitui autorização geral de tratamento de dados pessoais sensíveis além das hipóteses legais aplicáveis.
`
